import React from 'react';
import PropTypes from 'prop-types';
import { useTextResources, useTextOr } from '@/language';

const RestrictionTooltip = ({ row, testId }) => {
    const text = useTextResources();
    const textOr = useTextOr();
    const yesNo = (value) => text(value ? 'Yes' : 'No');

    return (
        <div style={{ padding: '5px' }} data-testId={testId}>
            <div data-testId={`${testId}.updatedByUser`}>{`${text('User')}: ${row.UpdatedByUserName || ''}`}</div>
            <div data-testId={`${testId}.allowExternalUpdate`}>{`${text('UpdateFromExternalChannel')}: ${yesNo(row.AllowExternalUpdate)}`}</div>
            <div data-testId={`${testId}.isSuggested`}>{`${textOr('IsSuggested', 'Suggested')}: ${yesNo(row.IsSuggested)}`}</div>
            <div data-testId={`${testId}.rmsUpdateId`}>{`${textOr('RmsUpdateId', 'RMS Update Id')}: ${row.RmsUpdateId || ''}`}</div>
        </div>
    );
};

RestrictionTooltip.propTypes = {
    row: PropTypes.object.isRequired,
    testId: PropTypes.string.isRequired,
};

export default RestrictionTooltip;
